/* eslint-disable */
/* eslint-disable no-undef */
document.querySelectorAll('a[href="##"]')
  .forEach(input => input.addEventListener('click', (e) => {
    e.preventDefault();
    e.target.parentElement.classList.toggle('menu-active');

    jQuery(e.target).next('.sub-menu').slideToggle();
  }));

jQuery('.btn__menu-mobile, .menu-wrapper .container .icon-g-close, .area-menu .icon-g-close').on('click', () => {
  jQuery('body').toggleClass('no-scroll');
  jQuery('.area-menu__navigation li').removeClass('menu-item-has-children--open');
});

jQuery('#menu-mobile .menu-item-has-children .menu-item-has-children a').on('click', function () {
  jQuery(this).next('.sub-menu').toggleClass('active');
  jQuery(this).toggleClass('active');
  jQuery(this).parent().toggleClass('open-submenu');
});

jQuery('.click').click(() => {
  jQuery('.search-content #search').focus();
  jQuery('.container-find').addClass('search-active');
});

document.addEventListener('keyup', (e) => {
  if (e.keyCode == 27) {
    jQuery('.container-find').removeClass('search-active');
  }
});

jQuery('#close-search, #close-search.icon-g-close').click(() => {
  jQuery('.container-find').removeClass('search-active');
});

jQuery(document).click((event) => {
  if (!jQuery(event.target).closest('.container-find').length) {
    if (jQuery('.container-find').is(':visible')) {
      jQuery('.container-find').removeClass('search-active');
    }
  }
});

jQuery(document).ready(() => {
  jQuery('ul.tabs li').click(function () {
    const tabId = jQuery(this).attr('data-tab');

    jQuery('ul.tabs li').removeClass('current');
    jQuery('.tab-content').removeClass('current');

    jQuery(this).addClass('current');
    jQuery(`#${tabId}`).addClass('current');

    jQuery('.item').css('margin-bottom', '30px');
  });
});

jQuery('img').on('error', function () {
  jQuery(this).unbind('error').parents('.card').addClass('error');
});

jQuery('.swiper-slide label').on('click', function () {
  jQuery('.swiper-slide label').removeClass('active');
  jQuery(this).addClass('active');
});

// if (window.innerWidth > 1024) {
//   jQuery(window).on('load', function() {
//     let side = jQuery('.sidebar').height();
//     let scroll = window.innerHeight-110;
//     jQuery(window).scroll(function(){
//       if (jQuery(this).scrollTop() + scroll-110 >= side ) {
//         jQuery('.single .sidebar').addClass('sidebar-fixed');
//       } else {
//         jQuery('.sidebar').removeClass('sidebar-fixed');
//       }
//     });
//   });
// }
